// extracted by mini-css-extract-plugin
module.exports = {"newsContainer":"newsContainer-module--newsContainer--2B89K","newsContainerIE":"newsContainer-module--newsContainerIE--1sQSR"};